import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Typography from '@material-ui/core/Typography';

import TextLink from 'src/components/TextLink';
import useStyles from './useStyles';

const DefaultOptions = ({ className, classes, options, onSelect, disabled, generalOption }) => {
  const styles = useStyles({ classes });

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="DefaultOptions"
    >
      {generalOption ? (
        <Typography className={styles.title}>
          Use{' '}
          <TextLink
            onClick={() => onSelect(generalOption)}
            disabled={disabled}
            data-testid={`DefaultOptions__${generalOption.name}Link`}
          >
            {generalOption.name}
          </TextLink>{' '}
          data set instead (most likely to work with most copy).
        </Typography>
      ) : (
        <>
          <Typography className={styles.title}>
            We couldn’t find anything that matched your search.
          </Typography>
          <div className={styles.options}>
            {options.map((option) => (
              <TextLink
                className={styles.option}
                key={option.id}
                onClick={() => onSelect(option)}
                disabled={disabled}
                data-testid={`DefaultOptions__${option.name}Link`}
              >
                {option.name}
              </TextLink>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

DefaultOptions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  generalOption: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
};

DefaultOptions.defaultProps = {
  className: null,
  classes: null,
  disabled: false,
  generalOption: null,
};

export default React.memo(DefaultOptions);
